import * as ngCommon from '@angular/common'
import { Component } from '@angular/core'

import * as tabs from '../tabs'

@Component({
  imports: [ngCommon.NgTemplateOutlet],
  selector: 'atn-ds-integrated-horizontal-tabs',
  styleUrls: ['./integrated-horizontal-tabs.component.scss'],
  templateUrl: './integrated-horizontal-tabs.component.html',
})
export class AtnDsIntegratedHorizontalTabsComponent extends tabs.Component {}
